import { useState } from 'react';
import { api } from '../api';
import { useIch, useSitzung } from '../sitzung';
import { Eingabe, Feld, Karte, Knopf, Meldung, useAktion } from '../ui';
import { PasswortFormular } from './Zugang';

export function Konto() {
  const ich = useIch();
  const { neuLaden } = useSitzung();
  const [name, setName] = useState(ich.anzeigename);
  const [ok, setOk] = useState('');
  const a = useAktion();
  return (
    <div className="seite schmal">
      <h1>Mein Konto</h1>
      <Karte titel="Profil">
        <div className="stapel">
          <Feld titel="Benutzername">
            <Eingabe value={ich.benutzername} disabled />
          </Feld>
          <Feld titel="Anzeigename">
            <Eingabe value={name} onChange={(e) => setName(e.target.value)} />
          </Feld>
          <Meldung>{a.fehler}</Meldung>
          <Meldung art="ok">{ok}</Meldung>
          <Knopf
            art="haupt"
            disabled={a.laeuft || !name.trim() || name === ich.anzeigename}
            onClick={async () => {
              if (await a.ausfuehren(() => api.patch('/api/ich', { anzeigename: name }))) {
                setOk('Gespeichert');
                await neuLaden();
              }
            }}
          >
            Speichern
          </Knopf>
        </div>
      </Karte>
      <Karte titel="Passwort ändern">
        <PasswortFormular fertig={() => setOk('Passwort geändert – andere Geräte wurden abgemeldet.')} />
      </Karte>
    </div>
  );
}
